import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {useNavigate} from "react-router-dom";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const ParentsConsultAddRequestModal = (props: { active: boolean, closeHandler: any }) => {
    const ids = {
        title:useId(),
        message:useId(),
    };
    const [title,setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [err,setErr] = useState({
        title:false,
        message:false,
    });
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setTitle('');
            setMessage('');
            setErr({
                message: false,
                title: false,
            });
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const navigate = useNavigate();
    const sendMessage = () => {
        const data = {
            title:title.trim(),
            message:message.trim(),
        };
        let errors = {
            title:false,
            message:false,
        };
        let stop = false;
        if(data.title.length < 2){
            errors.title = true;
            stop = true;
        }
        if(data.message.length < 2){
            errors.message = true;
            stop = true;
        }
        setErr(errors);
        if(stop)
            return;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/consult/requests/add',
            data,
            true,
            (d: {
                result: string,
                reason: string,
                id:number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                props.closeHandler();
                ShowSnackbar(
                    'درخواست شما به مشاور مدرسه ارسال گردید.',
                    'باشه',
                    5000,
                );
                navigate('/students/consult/requests/view/' + d.id.toString());
            },
            () => {},
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>درخواست مشاوره</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label htmlFor={ids.title} data-necessary="yes">موضوع مشاوره:</label>
                        <input type="text"
                               id={ids.title}
                               className={"form-control" + (err.title ? ' is-invalid' : '')}
                               value={title}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setTitle(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.title = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.title ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد نمایید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.message} data-necessary="yes">پیام شما به مشاور:</label>
                        <textarea id={ids.message}
                               className={"form-control" + (err.message ? ' is-invalid' : '')}
                               value={message}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setMessage(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.message = false;
                                       return x;
                                   });
                               }}
                                  style={{minHeight:150,maxHeight:300}}
                        />
                        <div className={"invalid-feedback" + (err.message ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد نمایید.
                        </div>
                        <div style={{height: 20}}/>
                        <div className="d-flex justify-content-end" style={{gap:5}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={sendMessage}>
                                <b>ارسال درخواست</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};